/**
 *
 * @param parsedRules {ParsedPermissions}
 * @param ruleString {String}
 * @returns {boolean}
 */
export function checkAccess (parsedRules, ruleString) {
	const stipedRule = ruleString.split('.').map((e) => e.trim()).filter(Boolean);
	for (const rule of parsedRules) {
		const currentRule = rule.path.join('.');
		if (rule.mode === 'deny') {
			if (currentRule === ruleString) return false;
			for (let i = 0; i < rule.path.length; i++) {
				const currentLayer = rule.path[i];
				// Если слои закончились то выходим из цикла
				if (!stipedRule[i]) break;
				// Если название слоя совпадает с аналогичным в схеме правил то продолжаем итерацию
				if (stipedRule[i] === currentLayer) continue;
				// Если находим спецсивол значит дальнейшая итерация бесполезна и нам туда уж точно нельзя
				if (currentLayer === '*') return false;
				// Если название слоёв не совпадает то выходим из цикла
				if (stipedRule[i] !== currentLayer) break;
			}
		}
		if (rule.mode === 'allow') {
			for (let i = 0; i < rule.path.length; i++) {
				const prevStr = rule.path.slice(0, i)
					.filter(Boolean)
					.join('.');
				const currentStr = rule.path[i];
				const partStr = [prevStr, currentStr].filter(Boolean)
					.join('.');

				if (prevStr && !ruleString.startsWith(prevStr)) break;
				if (currentStr === '*') return true;
				if (partStr === ruleString) return true;
			}
		}
	}
	return false;
}
